import { render, staticRenderFns } from "./AccountFooter.vue?vue&type=template&id=51122d85&"
import script from "./AccountFooter.vue?vue&type=script&lang=js&"
export * from "./AccountFooter.vue?vue&type=script&lang=js&"
import style0 from "./AccountFooter.vue?vue&type=style&index=0&id=51122d85&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports